import { useLocation } from 'react-router-dom'
import { MODULES, type MenuModule, type MenuSubItem } from './menu'

export interface ActiveMenu {
  module: MenuModule
  item: MenuSubItem | null
}

/** Aktif rotaya karşılık gelen modül + (yaprak) alt öğeyi döndürür (breadcrumb/başlık/aktif vurgu için). */
export function useActiveMenu(): ActiveMenu | null {
  const { pathname } = useLocation()
  for (const module of MODULES) {
    for (const item of module.items) {
      // Grup öğelerinde (children) yaprakları tara; aksi halde öğenin kendisi.
      const leaves = item.children ?? [item]
      for (const leaf of leaves) {
        if (leaf.path && (pathname === leaf.path || pathname.startsWith(`${leaf.path}/`))) {
          return { module, item: leaf }
        }
      }
    }
  }
  for (const module of MODULES) {
    if (pathname === module.basePath || pathname.startsWith(`${module.basePath}/`)) {
      return { module, item: null }
    }
  }
  return null
}
